import React from 'react';
import { Female } from '../Icons';

import styles from '../../components/GymHeader/GymHeader.module.scss';

const LadiesOnly: React.FC = () => {
  return (
    <span className={styles['gym-header__ladies-only']}>
      <span className={styles['gym-header__ladies-only-icon']}>
        <Female />
      </span>
      <span className={styles['gym-header__ladies-only-name']}>Ladies only gym</span>
    </span>
  );
};

export { LadiesOnly };
